import { SubfolderDetailView } from '@/features/AssetDetailView/FolderDetailView/SubfolderDetailView';
import { createFileRoute } from '@tanstack/react-router';

type SubfolderSearchParams = {
    docId?: number;
    rowIndex?: number;
    insight?: number;
    serialNumber?: string;
};

function parseOptionalNonNegativeInt(value: unknown): number | undefined {
    if (value === undefined || value === null || value === '') return undefined;
    const n = Number(value);
    return Number.isInteger(n) && n >= 0 ? n : undefined;
}

function parseOptionalString(value: unknown): string | undefined {
    if (value === undefined || value === null || value === '') return undefined;
    return String(value);
}

export function validateSubfolderDetailSearch(
    search: Record<string, unknown>,
): SubfolderSearchParams {
    return {
        docId: parseOptionalNonNegativeInt(search.docId),
        rowIndex: parseOptionalNonNegativeInt(search.rowIndex),
        insight: parseOptionalNonNegativeInt(search.insight),
        serialNumber: parseOptionalString(search.serialNumber),
    };
}

export const Route = createFileRoute(
    '/asset_collection/$collectionId/assets/$assetId/projects/$projectId/folders/$folderLetter/subfolders/$subFolderType/$subFolderId/',
)({
    component: SubfolderDetailView,
    validateSearch: validateSubfolderDetailSearch,
});
